var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 6.87504C8.27395 6.87504 6.87484 8.27415 6.87484 10C6.87484 11.7259 8.27395 13.125 9.99984 13.125C11.7257 13.125 13.1248 11.7259 13.1248 10C13.1248 8.27415 11.7257 6.87504 9.99984 6.87504ZM8.12484 10C8.12484 8.96451 8.9643 8.12504 9.99984 8.12504C11.0354 8.12504 11.8748 8.96451 11.8748 10C11.8748 11.0356 11.0354 11.875 9.99984 11.875C8.9643 11.875 8.12484 11.0356 8.12484 10Z",
    fill: "#1A1B1D",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.70837C6.23806 2.70837 3.70425 4.96187 2.23364 6.87243L2.20712 6.90687C1.87454 7.33882 1.56822 7.73664 1.36041 8.20704C1.13787 8.71077 1.0415 9.25978 1.0415 10C1.0415 10.7403 1.13787 11.2893 1.36041 11.793C1.56822 12.2634 1.87454 12.6613 2.20713 13.0932L2.23364 13.1277C3.70425 15.0382 6.23806 17.2917 9.99984 17.2917C13.7616 17.2917 16.2954 15.0382 17.766 13.1277L17.7925 13.0932C18.1251 12.6613 18.4314 12.2634 18.6393 11.793C18.8618 11.2893 18.9582 10.7403 18.9582 10C18.9582 9.25978 18.8618 8.71077 18.6393 8.20704C18.4314 7.73663 18.1251 7.33881 17.7925 6.90685L17.766 6.87243C16.2954 4.96187 13.7616 2.70837 9.99984 2.70837ZM3.22419 7.63487C4.58203 5.87081 6.7918 3.95837 9.99984 3.95837C13.2079 3.95837 15.4176 5.87081 16.7755 7.63487C17.141 8.1097 17.3551 8.39342 17.4959 8.71216C17.6275 9.01005 17.7082 9.37415 17.7082 10C17.7082 10.6259 17.6275 10.99 17.4959 11.2879C17.3551 11.6067 17.141 11.8904 16.7755 12.3652C15.4176 14.1293 13.2079 16.0417 9.99984 16.0417C6.7918 16.0417 4.58204 14.1293 3.22419 12.3652C2.8587 11.8904 2.64462 11.6067 2.5038 11.2879C2.3722 10.99 2.2915 10.6259 2.2915 10C2.2915 9.37415 2.3722 9.01005 2.5038 8.71216C2.64462 8.39342 2.8587 8.1097 3.22419 7.63487Z",
    fill: "#1A1B1D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.d7fb38a00dfa2cc63fb3be4a5f8ba989.svg";
export { ForwardRef as ReactComponent };